"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMediaEngineImpl = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const IrisClientObserver_1 = require("../engine/IrisClientObserver");
const AgoraConsole_1 = require("../util/AgoraConsole");
const BufferConvert_1 = require("../util/BufferConvert");
const IAgoraRtcEngineImpl_1 = require("./IAgoraRtcEngineImpl");
//@ts-ignore
class IMediaEngineImpl {
    constructor(engine) {
        this._engine = engine;
    }
    setExternalVideoSource_fff99b6(enabled, useTexture, sourceType, encodedVideoOption) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.pushVideoFrameEnabled = enabled;
            this._engine.globalState.pushVideoFrameUseTexture = useTexture;
            this._engine.globalState.pushVideoFrameSourceType = sourceType;
            this._engine.globalState.pushVideoFrameEncodedVideoOption = encodedVideoOption;
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    pushVideoFrame_4e544e2(frame, videoTrackId) {
        //调用engine.release后才会创建新的track
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            if (this._engine.globalState.enabledVideo == false) {
                AgoraConsole_1.AgoraConsole.error('call enableVideo(true) before startPreview');
                return this._engine.returnResult();
            }
            if (!this._engine.globalState.pushVideoFrameEnabled) {
                AgoraConsole_1.AgoraConsole.error('pushVideoFrameEnabled is disabled , call setExternalVideoSource_fff99b6 first');
                return this._engine.returnResult();
            }
            //创建custom track的html element
            let irisContainer = this._engine.irisElement.getIrisElement();
            if (!irisContainer) {
                irisContainer = this._engine.irisElement.createIrisElement();
            }
            let canvasID = `MediaEngine_pushVideoFrame_CANVAS`;
            let canvas = document.querySelector(`#${canvasID}`);
            if (!canvas) {
                canvas = document.createElement('canvas');
                canvas.id = canvasID;
                canvas.style.display = 'none';
            }
            if (frame.format !== NATIVE_RTC.VIDEO_PIXEL_FORMAT.VIDEO_PIXEL_BGRA &&
                frame.format !== NATIVE_RTC.VIDEO_PIXEL_FORMAT.VIDEO_PIXEL_RGBA) {
                AgoraConsole_1.AgoraConsole.error(`format${frame.format} not supported`);
                return this._engine.returnResult(false, -NATIVE_RTC.ERROR_CODE_TYPE.ERR_NOT_SUPPORTED);
            }
            (0, BufferConvert_1.drawRGBABufferToCanvas)(frame.stride, frame.height, frame.buffer, frame.format, canvas);
            irisContainer.appendChild(canvas);
            document.body.appendChild(irisContainer);
            const stream = canvas.captureStream();
            let mediaStreamTrack = stream.getVideoTracks()[0];
            let videoType = NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CUSTOM;
            let videoTrackPackage;
            try {
                videoTrackPackage = yield this._engine.implHelper.createCustomVideoTrack(videoType, mediaStreamTrack);
            }
            catch (err) {
                err && AgoraConsole_1.AgoraConsole.error(err);
                return this._engine.returnResult(false);
            }
            let videoTrack = videoTrackPackage.track;
            if (videoTrack) {
                if (!videoTrack.enabled) {
                    yield this._engine.trackHelper.setEnabled(videoTrack, true);
                }
                //如果没有播放，需要play
                if (!videoTrack.isPlaying && videoTrackPackage.element) {
                    this._engine.trackHelper.play(videoTrack, videoTrackPackage.element);
                }
                yield this._engine.irisClientManager.irisClientObserver.notifyLocal(IrisClientObserver_1.NotifyType.PUBLISH_TRACK, [videoTrackPackage], this._engine.irisClientManager.irisClientList);
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    registerAudioFrameObserver_d873a64(observer) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.irisEventHandlerManager.addEventHandler(IAgoraRtcEngineImpl_1.RTCENGINE_KEY, observer);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
    unregisterAudioFrameObserver(observer) {
        let processFunc = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.irisEventHandlerManager.removeEventHandler(IAgoraRtcEngineImpl_1.RTCENGINE_KEY, observer);
            return this._engine.returnResult();
        });
        return this._engine.execute(processFunc);
    }
}
exports.IMediaEngineImpl = IMediaEngineImpl;
